module.exports = "https://trybtryb-legacy.web.app/img/to_right.01ad5e52.svg";